import { api } from 'app/util/api'
import { route } from 'preact-router'
import { initialState } from './'

// Create, Find, Get, Remove

const actions = () => ({
  /**
   * Authentication
   *
   */
  async login(state, email, password) {
    const { accessToken, refreshToken, expiration } = await api.post('/auth/sign-in', {
      email,
      password,
    })

    route('/')

    return {
      auth: { ...state.auth, accessToken, refreshToken, email, expiration },
    }
  },

  async register(state, data) {
    const { accessToken, refreshToken, expiration } = await api.post('/auth/sign-up', { ...data })

    // route('/')

    return {
      auth: { ...state.auth, accessToken, refreshToken, email: data.email, expiration },
    }
  },

  logout: () => initialState,

  async getMe(state) {
    const { email, username } = await api.get('/me/')

    return { me: { ...state.me, email, username } }
  },
})

export default actions



// WEBPACK FOOTER //
// ./store/actions.js